export enum EkorpAkceButtonType {
    SRD_DETAIL_TL_VHZRUS = 'SRD_DETAIL_TL_VHZRUS',
    SRD_DETAIL_TL_VH = 'SRD_DETAIL_TL_VH',
    SRD_DETAIL_TL_VYPIS = 'SRD_DETAIL_TL_VYPIS',
    SRD_DETAIL_TL_VYPISZRUS = 'SRD_DETAIL_TL_VYPISZRUS',
    SRD_DETAIL_TL_VYPISODP = 'SRD_DETAIL_TL_VYPISODP',
    SRD_DETAIL_TL_VHODP = 'SRD_DETAIL_TL_VHODP',
    SRD_DETAIL_TL_VHODPZRUS = 'SRD_DETAIL_TL_VHODPZRUS',
    SRD_DETAIL_TL_POT = 'SRD_DETAIL_TL_POT',
    SRD_DETAIL_TL_STR = 'SRD_DETAIL_TL_STR',
    SRD_DETAIL_TL_ZAP = 'SRD_DETAIL_TL_ZAP',
    SRD_DETAIL_TL_VYSL = 'SRD_DETAIL_TL_VYSL',
    SRD_DETAIL_TL_JINA = 'SRD_DETAIL_TL_JINA'
}
interface IKorpAkceStructure {
    type: EkorpAkceButtonType;
    text: string;
}
export const korpAkceStructure: IKorpAkceStructure[] = [
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_VHZRUS,
        text: 'SRD_DETAIL_INFO_VHZRUS'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_VH,
        text: 'SRD_DETAIL_INFO_VH'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_VYPIS,
        text: 'SRD_DETAIL_INFO_VYPIS'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_VYPISZRUS,
        text: 'SRD_DETAIL_INFO_VYPISZRUS'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_VYPISODP,
        text: 'SRD_DETAIL_TL_VYPISODP'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_VHODPZRUS,
        text: 'SRD_DETAIL_TL_VHODPZRUS'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_VHODP,
        text: 'SRD_DETAIL_TL_VHODP'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_POT,
        text: 'SRD_DETAIL_INFO_POT'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_STR,
        text: 'SRD_DETAIL_INFO_STR'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_ZAP,
        text: 'SRD_DETAIL_INFO_ZAP'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_VYSL,
        text: 'SRD_DETAIL_INFO_VYSL'
    },
    {
        type: EkorpAkceButtonType.SRD_DETAIL_TL_JINA,
        text: 'SRD_DETAIL_INFO_JINA'
    }
];
